import { Badge } from "@/components/ui/badge";
import { FlaskConical } from "lucide-react";
import type { CommercialFlags } from "@/hooks/use-commercial-status";

interface CommercialStatusBadgesProps {
  flags: CommercialFlags;
  className?: string;
  size?: "sm" | "default";
}

export const CommercialStatusBadges = ({ flags, className = "", size = "default" }: CommercialStatusBadgesProps) => {
  if (!flags?.isPilot) return null;

  const textSize = size === "sm" ? "text-[10px] px-1.5 py-0" : "text-xs";
  const iconSize = size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3";

  return (
    <div className={`flex flex-wrap items-center gap-1 ${className}`}>
      {flags.isPilot && (
        <Badge
          variant="outline"
          className={`${textSize} flex items-center gap-1 border-teal-300 bg-teal-50 text-teal-800`}
        >
          <FlaskConical className={iconSize} />
          Pilot Pack
        </Badge>
      )}
    </div>
  );
};
